<div class="div-arriere-plan-action" (click)="closeValidationPopup()"></div>
<div class="center-square align-items-center">
  <img class="close-icon" src="assets/close_cross_black.svg" (click)="closeValidationPopup()">
  <img src="assets/blue-valid-icon.svg" class="result-image">
  <h1 class="light-blue">
    TRANSFERT CONFIRMÉ
  </h1>
  <p class="dark-blue text-center">L’adresse email a été mise à jour et l’invitation a été transférée avec succès vers la nouvelle</p>

  <p class="dark-blue pointer" (click)="closeValidationPopup()">Fermer</p>
</div>